export default __webpack_public_path__ + "static/media/Sutton-Screenshot_Easy-Resize.com.1561b22f.jpg";